import {brand, Branded, TypeOf} from 'io-ts';
import {NonEmptyString} from '../NonEmptyString';

export const CurrencySign = brand(
    NonEmptyString,
    (_): _ is Branded<NonEmptyString, {readonly CurrencySign: unique symbol}> => true,
    'CurrencySign'
);
export type CurrencySign = TypeOf<typeof CurrencySign>;
